var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container px-2 pr-4" }, [
    _c(
      "div",
      { attrs: { id: "document-carousel-slide" } },
      [
        _vm.isCarouselReady
          ? _c(
              "VueSlickCarousel",
              _vm._b(
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "nextArrow",
                        fn: function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "custom-arrow-next",
                                attrs: { type: "button" }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--ko-chevron-right"
                                })
                              ]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "prevArrow",
                        fn: function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "custom-arrow-prev",
                                attrs: { type: "button" }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--ko-chevron-left"
                                })
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3332624018
                  )
                },
                "VueSlickCarousel",
                _vm.settings,
                false
              ),
              [
                _vm._v(" "),
                _vm._v(" "),
                _vm.collectionData &&
                _vm.collectionData.customData &&
                _vm.collectionData.customData.lookBookPdf
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.IconLookBook,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text-img lookbook-pdf-download",
                            attrs: {
                              target: "_blank",
                              href: _vm.collectionData.customData.lookBookPdf.replace(
                                /^~\//,
                                "/"
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.collectionData.customData.lookBookTitle
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProduct && _vm.selectedProduct.pdmsLink
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.FullProductSpec,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text spec-pdf-download",
                            attrs: {
                              target: "_blank",
                              href: _vm.selectedProduct.pdmsLink
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Detail.Label.FullProductSpec"
                                  ]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isResinous
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.IconConstructionSpec,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text technical-document-download",
                            attrs: {
                              target: "_blank",
                              href:
                                "/Product/ConstructionSpec/" +
                                (_vm.productData &&
                                  _vm.productData.sellingStyleNumber)
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Detail.Label.ConstructionSpec"
                                  ]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productData &&
                _vm.productData.installationLinks &&
                _vm.productData.installationLinks.length
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.IconInstallation,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text",
                            attrs: {
                              target: "_blank",
                              href: _vm.productData.installationLinks[0].link
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Detail.Title.Installation"
                                  ]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productData &&
                _vm.productData.maintenanceLinks &&
                _vm.productData.maintenanceLinks.length
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.IconMaintenance,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text",
                            attrs: {
                              target: "_blank",
                              href: _vm.productData.maintenanceLinks[0].link
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Detail.Title.Maintenance"
                                  ]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productData &&
                _vm.productData.warrantyLinks &&
                _vm.productData.warrantyLinks.length
                  ? _c(
                      "div",
                      { staticClass: "text-center carousel-img-width" },
                      [
                        _c("img", {
                          staticClass: "widget-img-view",
                          attrs: {
                            src: _vm.imageData.IconWarranty,
                            alt: "img"
                          },
                          on: { error: _vm.handleImageError }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "font-size-12 text-uppercase caption-text",
                            attrs: {
                              target: "_blank",
                              href: _vm.productData.warrantyLinks[0].link
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Detail.Label.WarrantyLifetime"
                                  ]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }